import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/system/device/device'; // import { fetchList } from '@/api/system/target/target'

import { fetchListByType } from '@/api/system/dic/dic'; // import { fetchTreeList } from '@/api/system/floor/floor'

export default {
  data: function data() {
    var _this = this;

    var validateDev = function validateDev(rule, value, callback) {
      if (_this.partitionList.length !== 3) {
        callback(new Error('请选择设备楼层'));
      } else {
        callback();
      }
    };

    return {
      brandOption: [],
      sysTypeOption: [],
      floorOption: [],
      targetOption: [],
      floorTreeProps: {
        label: 'name',
        value: 'id',
        children: 'childDev'
      },
      rules: {
        deviceSerno: [{
          required: true,
          message: '请输入设备编码',
          trigger: 'change'
        }],
        deviceName: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'change'
        }],
        partitionList: [{
          required: true,
          validator: validateDev,
          trigger: 'change'
        }],
        brandNameValue: [{
          required: true,
          message: '请选择设备品牌',
          trigger: 'change'
        }],
        sysType: [{
          required: true,
          message: '请选择设备归属系统',
          trigger: 'change'
        }],
        deviceFlag: [{
          required: true,
          message: '请选择设备标识',
          trigger: 'change'
        }],
        deviceState: [{
          required: true,
          message: '请选择设备使用状态',
          trigger: 'change'
        }]
      },
      deviceId: -1,
      childData: {},
      partitionList: []
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs['dataForm'].resetFields();

        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  methods: {
    init: function init() {
      this.brandOption = [];
      this.sysTypeOption = [];
      this.floorOption = [];
      this.targetOption = [];
      this.loadBrand();
      this.loadSysType();
      this.loadData(); // this.loadTarget()
      // this.loadFloor()
    },
    loadTarget: function loadTarget() {
      var _this2 = this;

      fetchList({}).then(function (r) {
        _this2.targetOption = r.data.data;
      });
    },
    loadFloor: function loadFloor() {
      var _this3 = this;

      fetchTreeList({}).then(function (r) {
        _this3.floorOption = r.data.data;
      });
    },
    changeSysValue: function changeSysValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.sysTypeName = obj.dicName;
    },
    changeBrandValue: function changeBrandValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.brandNameValue = obj.dicName;
    },
    loadBrand: function loadBrand() {
      var _this4 = this;

      fetchListByType('brand_name').then(function (r) {
        _this4.brandOption = r.data.data;
      });
    },
    loadSysType: function loadSysType() {
      var _this5 = this;

      fetchListByType('sys_type').then(function (r) {
        _this5.sysTypeOption = r.data.data;
      });
    },
    loadData: function loadData() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          deviceId: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this6.childData = response.data.data;
          var targetIds = [];
          _this6.partitionList = [];

          if (response.data.data.targetIds != null) {
            response.data.data.targetIds.split(',').forEach(function (e) {
              targetIds.push(e);
            });
          }

          _this6.childData.targetIds = targetIds;
          _this6.childData.deviceState = response.data.data.deviceState.toString();
          _this6.childData.deviceFlag = response.data.data.deviceFlag.toString();

          _this6.partitionList.push(response.data.data.areaGroupId.toString());

          response.data.data.partitionList.forEach(function (r) {
            _this6.partitionList.push(r);
          });
        });
      } else {
        this.partitionList = [];
        this.childData = {
          targetIds: []
        };
      }
    },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this7.childData.floorId = _this7.partitionList[_this7.partitionList.length - 1];
          delete _this7.childData.partitionList;
          delete _this7.childData.partitionId;
          delete _this7.childData.updateTime;
          delete _this7.childData.deviceState;
          delete _this7.childData.deviceValue;

          if (_this7.keyValue > 0) {
            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this7.childData).then(function () {
              _this7.keyValue = -1;

              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};